import React from "react";

import { Stack } from "@mui/material"

import { RankQualPvTvBox } from "./RankQualPvTvBox";


const RankQualPvTvBoxes = ({
  selectedRankDetails,
  totalOv,
  inDrawer,
  isError,
  pvBreakdownStatus,
  pvBreakdownData,
}) => {
  const pv = selectedRankDetails?.metrics?.filter(item => item.name === "pv")[0] || {};
  const tv = selectedRankDetails?.metrics?.filter(item => item.name === "tv")[0] || {};
  const activeLegs = selectedRankDetails?.metrics?.filter(item => item.name === "active_legs")[0] || {};

  return (
    <Stack
      direction="row"
      flexWrap="wrap"
      gap="12px"
      mb={inDrawer ? 1 : 3}
      ml={2.5}
      mr={2.5}
    >
      <Stack
        direction="row"
        gap={1}
        flexGrow={1}
        flexWrap={"wrap"}
      >
        {
          (pv || isError) &&
          <RankQualPvTvBox
            data-test-id="pv-qualification-box"
            type="pv"
            inDrawer={inDrawer}
            values={pv}
            isError={isError}
            selectedRankDetails={selectedRankDetails}
            pvBreakdownStatus={pvBreakdownStatus}
            pvBreakdownData={pvBreakdownData}
          />
        }
        {
          (tv || isError) &&
          <RankQualPvTvBox
            data-test-id="tv-qualification-box"
            type="tv"
            inDrawer={inDrawer}
            values={tv}
            isError={isError}
            selectedRankDetails={selectedRankDetails}
          />
        }
      </Stack>
      <Stack
        direction="row"
        gap={1}
        flexGrow={1}
        flexWrap={"wrap"}>
        {
          (activeLegs || isError) &&
          <RankQualPvTvBox
            data-test-id="active-legs-qualification-box"
            type="active_legs"
            inDrawer={inDrawer}
            values={activeLegs}
            isError={isError}
            selectedRankDetails={selectedRankDetails}
          />
        }
        {
          (totalOv || isError) &&
          <RankQualPvTvBox
            data-test-id="total-ov-qualification-box"
            type="total_ov"
            inDrawer={inDrawer}
            values={totalOv}
            isError={isError}
            selectedRankDetails={selectedRankDetails}
          />
        }
      </Stack>
    </Stack>
  )
}

export { RankQualPvTvBoxes }